/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import DevelopmentTable from './tables/DevelopmentTable';
import './masterRemedy.css';
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import {
  AddIcon,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
  Textarea,
  Select as ChakraSelect,
} from '@chakra-ui/icons';
import { useForm } from 'react-hook-form';
// import AddDiseaseProtocol from './addDiseaseProtocol';

const MasterRemedy = () => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      remedyCode: '',
      remedyName: '',
      polarity: '',
      primaryAxis: '',
      secondaryAxis: '',
      defaultElectricity: '',
      coreAction: '',
      clinicalTags: '',
      polarityLevel: '',
    },
  });

  const [axisData, setAxisData] = useState([
    {
      _id: 1,
      remedyCode: 'S1',
      remedyName: 'Scrofoloso-1',
      polarity: '(–) Negative',
      primaryAxis: 'LYM / SKN',
      secondaryAxis: 'NRV / MUC',
      defaultElectricity: 'B.E.(–)',
      coreAction:
        'Detoxifies lymph & glands, clears skin toxins, improves mucosal flow',
      clinicalTags:
        'eczema, psoriasis, lymph swelling, chronic skin eruptions, toxemia, dermatitis',
      polarityLevel: '1',
    },
    {
      _id: 2,
      remedyCode: 'S2',
      remedyName: 'Scrofoloso-2',
      polarity: '(+) Positive',
      primaryAxis: 'NRV / MUC',
      secondaryAxis: 'DIG / HEP',
      defaultElectricity: 'G.E.(+)',
      coreAction:
        'Regulates nerve tone, improves digestion, supports mucosal integrity',
      clinicalTags:
        'nervousness, gastritis, indigestion, anxiety, mucosal dryness',
      polarityLevel: '2',
    },
    {
      _id: 3,
      remedyCode: 'S3',
      remedyName: 'Scrofoloso-3',
      polarity: '(±) Bipolar',
      primaryAxis: 'HEP / DIG',
      secondaryAxis: 'BLO / LYM',
      defaultElectricity: 'R.E.(±)',
      coreAction: 'Enhances liver detox, improves bile flow, purifies blood',
      clinicalTags:
        'fatty liver, sluggish digestion, jaundice support, blood impurities',
      polarityLevel: '3',
    },
    {
      _id: 4,
      remedyCode: 'S4',
      remedyName: 'Scrofoloso-4',
      polarity: '(–) Negative',
      primaryAxis: 'REN / URN',
      secondaryAxis: 'BLO / LYM',
      defaultElectricity: 'B.E.(–)',
      coreAction:
        'Supports renal filtration, reduces edema, balances fluid retention',
      clinicalTags:
        'water retention, kidney weakness, edema, urinary complaints',
      polarityLevel: '1',
    },
    {
      _id: 5,
      remedyCode: 'S5',
      remedyName: 'Scrofoloso-5',
      polarity: '(+) Positive',
      primaryAxis: 'CAR / BLO',
      secondaryAxis: 'NRV / MUS',
      defaultElectricity: 'G.E.(+)',
      coreAction:
        'Improves circulation, strengthens cardiac rhythm, boosts vitality',
      clinicalTags: 'poor circulation, fatigue, palpitations, low stamina',
      polarityLevel: '2',
    },
    {
      _id: 6,
      remedyCode: 'S6',
      remedyName: 'Scrofoloso-6',
      polarity: '(±) Bipolar',
      primaryAxis: 'MUS / BON',
      secondaryAxis: 'NRV / CAR',
      defaultElectricity: 'R.E.(±)',
      coreAction:
        'Relieves muscular stiffness, improves joint mobility, supports nerves',
      clinicalTags: 'arthritis, muscle pain, stiffness, joint weakness',
      polarityLevel: '3',
    },
    {
      _id: 7,
      remedyCode: 'S7',
      remedyName: 'Scrofoloso-7',
      polarity: '(–) Negative',
      primaryAxis: 'SKN / MUC',
      secondaryAxis: 'LYM / BLO',
      defaultElectricity: 'B.E.(–)',
      coreAction:
        'Cleanses skin channels, reduces inflammation, improves elimination',
      clinicalTags: 'acne, boils, chronic rashes, allergic skin conditions',
      polarityLevel: '1',
    },
    {
      _id: 8,
      remedyCode: 'S8',
      remedyName: 'Scrofoloso-8',
      polarity: '(+) Positive',
      primaryAxis: 'END / MET',
      secondaryAxis: 'DIG / HEP',
      defaultElectricity: 'G.E.(+)',
      coreAction: 'Balances endocrine function, supports metabolism and energy',
      clinicalTags: 'thyroid imbalance, metabolic sluggishness, weight issues',
      polarityLevel: '2',
    },
  ]);

  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState('');

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchParams, setSearchParams] = useSearchParams();

  const handlePageChange = (newPage) => {
    setPage(newPage);
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', newPage);
    setSearchParams(newParams);
  };

  // 🚀 Submit handler
  const onSubmit = (data) => {
    const payload = { ...data };
    console.log(payload);
  };

  const handleBack = () => {
    reset();
    setEditId('');
    setShowForm(false);
  };
  return (
    <div style={{ marginTop: '90px' }}>
      {!showForm && (
        <DevelopmentTable
          tableData={axisData}
          handleDeleteUser={() => {}}
          onEdit={(doc) => {
            setShowForm(true);
            setEditId(doc?._id);
            setValue('remedyCode', doc?.remedyCode);
            setValue('remedyName', doc?.remedyName);
            setValue('polarity', doc?.polarity);
            setValue('primaryAxis', doc?.primaryAxis);
            setValue('secondaryAxis', doc?.secondaryAxis);
            setValue('defaultElectricity', doc?.defaultElectricity);
            setValue('coreAction', doc?.coreAction);
            setValue('clinicalTags', doc?.clinicalTags);
            setValue('polarityLevel', doc?.polarityLevel);
          }}
          handlePageChange={handlePageChange}
          page={page}
          totalPages={totalPages}
          topActionButton={{
            label: 'Add Master Remedy',
            title: 'Master Remedy',
            icon: <AddIcon />,
            onClick: () => {
              setShowForm(true);
            },
          }}
        />
      )}
      {showForm && (
        <div style={{ marginTop: '100px' }}>
          <div className="titleWrapper">
            <h2>
              {editId !== '' ? 'Update Master Remedy' : 'Add Master Remedy'}
            </h2>
            <Button size="sm" colorScheme="blue" onClick={handleBack}>
              Back
            </Button>
          </div>

          {/* FORM */}
          <div>
            <div style={{ marginTop: '20px' }} className="formWrapper">
              {/* Remedy Code */}
              <FormControl mb={4} isInvalid={errors.remedyCode} isRequired>
                <FormLabel>Remedy Code</FormLabel>
                <Input
                  placeholder="S1, S2, S8..."
                  {...register('remedyCode', {
                    required: 'Remedy code is required',
                  })}
                />
                <FormErrorMessage>
                  {errors.remedyCode?.message}
                </FormErrorMessage>
              </FormControl>

              {/* Remedy Name */}
              <FormControl mb={4} isInvalid={errors.remedyName} isRequired>
                <FormLabel>Remedy Name</FormLabel>
                <Input
                  placeholder="Scrofoloso-8"
                  {...register('remedyName', {
                    required: 'Remedy name is required',
                    minLength: { value: 3, message: 'Minimum 3 characters' },
                  })}
                />
                <FormErrorMessage>
                  {errors.remedyName?.message}
                </FormErrorMessage>
              </FormControl>

              {/* Polarity */}
              <FormControl mb={4} isInvalid={errors.polarity} isRequired>
                <FormLabel>Polarity</FormLabel>
                <ChakraSelect
                  placeholder="Select polarity"
                  {...register('polarity', {
                    required: 'Polarity is required',
                  })}
                >
                  <option value="(–) Negative">(–) Negative</option>
                  <option value="(+) Positive">(+) Positive</option>
                  <option value="(±) Bipolar">(±) Bipolar</option>
                </ChakraSelect>
                <FormErrorMessage>{errors.polarity?.message}</FormErrorMessage>
              </FormControl>

              {/* Primary Axis */}
              <FormControl mb={4} isInvalid={errors.primaryAxis} isRequired>
                <FormLabel>Primary Axis</FormLabel>
                <Input
                  placeholder="END / MET"
                  {...register('primaryAxis', {
                    required: 'Primary axis is required',
                  })}
                />
                <FormErrorMessage>
                  {errors.primaryAxis?.message}
                </FormErrorMessage>
              </FormControl>

              {/* Secondary Axis */}
              <FormControl mb={4} isInvalid={errors.secondaryAxis}>
                <FormLabel>Secondary Axis</FormLabel>
                <Input placeholder="DIG / HEP" {...register('secondaryAxis')} />
              </FormControl>

              {/* Default Electricity */}
              <FormControl
                mb={4}
                isInvalid={errors.defaultElectricity}
                isRequired
              >
                <FormLabel>Default Electricity</FormLabel>
                <ChakraSelect
                  placeholder="Select electricity"
                  {...register('defaultElectricity', {
                    required: 'Default electricity is required',
                  })}
                >
                  <option value="B.E.(–)">B.E.(–)</option>
                  <option value="G.E.(+)">G.E.(+)</option>
                  <option value="R.E.(±)">R.E.(±)</option>
                  <option value="W.E.(±)">W.E.(±)</option>
                </ChakraSelect>
                <FormErrorMessage>
                  {errors.defaultElectricity?.message}
                </FormErrorMessage>
              </FormControl>

              {/* Core Action */}
              <FormControl mb={4} isInvalid={errors.coreAction} isRequired>
                <FormLabel>Core Action</FormLabel>
                <Textarea
                  placeholder="Balances endocrine function, supports metabolism..."
                  {...register('coreAction', {
                    required: 'Core action is required',
                    minLength: { value: 10, message: 'Minimum 10 characters' },
                  })}
                />
                <FormErrorMessage>
                  {errors.coreAction?.message}
                </FormErrorMessage>
              </FormControl>

              {/* Clinical Tags */}
              <FormControl mb={4} isInvalid={errors.clinicalTags}>
                <FormLabel>Clinical Tags</FormLabel>
                <Textarea
                  placeholder="thyroid imbalance, metabolic sluggishness..."
                  {...register('clinicalTags')}
                />
              </FormControl>

              {/* Polarity Level */}
              <FormControl mb={4} isInvalid={errors.polarityLevel} isRequired>
                <FormLabel>Polarity Level</FormLabel>
                <ChakraSelect
                  placeholder="Select level"
                  {...register('polarityLevel', {
                    required: 'Polarity level is required',
                  })}
                >
                  <option value="1">1 (Low)</option>
                  <option value="2">2 (Medium)</option>
                  <option value="3">3 (High)</option>
                </ChakraSelect>
                <FormErrorMessage>
                  {errors.polarityLevel?.message}
                </FormErrorMessage>
              </FormControl>
            </div>
          </div>

          {/* Submit */}
          <div className="submitBtnWrapper">
            <Button colorScheme="teal" onClick={handleSubmit(onSubmit)}>
              {editId !== '' ? 'Update' : 'Submit'}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MasterRemedy;
